import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full px-5 py-12" style={{
    backgroundColor: '#000000'
  }} data-id="element-139">
      <div className="mx-auto max-w-4xl text-center" data-id="element-140">
        <h3 className="font-display text-xl font-bold text-white" data-id="element-141">
          Cherub Agency®
        </h3>
        <p className="mt-2 text-sm text-white/60" data-id="element-142">
          Educación financiera práctica para el mundo real.
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-143">
          <a href="mailto:soporte@cherubagency.com" className="inline-flex items-center gap-2 hover:text-white transition-colors" data-id="element-144">
            <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-145" />
            soporte@cherubagency.com
          </a>
          <a href="https://instagram.com/cherubagency" className="inline-flex items-center gap-2 hover:text-white transition-colors" data-id="element-146">
            <InstagramIcon className="w-4 h-4" aria-hidden="true" data-id="element-147" />
            @cherubagency
          </a>
        </div>

        <div className="mx-auto mt-8 h-px w-full max-w-sm bg-white/10" data-id="element-148" />

        <p className="mt-6 text-xs text-white/40 leading-relaxed" data-id="element-149">
          © Cherub Agency® 2026 — Todos los derechos reservados.
          <br data-id="element-150" />
          Prohibida la reproducción sin autorización expresa.
          <br data-id="element-151" />
          Este material es de uso educativo e informativo.
        </p>
      </div>
    </footer>;
}